class CartTool extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      const btn = event.target.closest('.cartTool-item');
      if (!btn) return;
      const id = btn.dataset.popup;
      if (!id) return;
      const targetPopup = document.getElementById(id);
      if (targetPopup) {
        // Close other open popups first
        document.querySelectorAll('.popup-toolDown.show').forEach((p) => p.classList.remove('show'));
        targetPopup.classList.add('show');
        document.querySelector('.previewCart')?.classList.add('active-tool');
      }
    });
  }
}

if (!customElements.get('cart-item-tool')) {
  customElements.define('cart-item-tool', CartTool);
}

class CartCancel extends HTMLElement {
  constructor() {
    super();
    this.querySelector('button')?.addEventListener('click', (event) => {
      document.querySelectorAll('.popup-toolDown.show').forEach((p) => p.classList.remove('show'));
      document.querySelector('.previewCart')?.classList.remove('active-tool');
    });
  }
}

if (!customElements.get('cart-cancel-popup')) {
  customElements.define('cart-cancel-popup', CartCancel);
}

class CartNote extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[data-update-note]')?.addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area')?.value || '';
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body })
        .then(() => {
          document.querySelectorAll('.popup-toolDown.show').forEach((p) => p.classList.remove('show'));
          document.querySelector('.previewCart')?.classList.remove('active-tool');
        })
        .catch(() => {
          document.querySelectorAll('.popup-toolDown.show').forEach((p) => p.classList.remove('show'));
          document.querySelector('.previewCart')?.classList.remove('active-tool');
        });
    });
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}

class CouponCode extends HTMLElement {
  constructor() {
    super();
    const discountInput = this.querySelector('input[name="discount"]');
    if (localStorage.getItem('storedDiscount') && discountInput) {
      discountInput.value = localStorage.getItem('storedDiscount');
    }
    this.querySelector('[data-update-coupon]')?.addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]')?.value || '';
      if (this.val) {
        localStorage.setItem('storedDiscount', this.val);
        fetch(`/discount/${encodeURIComponent(this.val)}`)
          .then((response) => response.text())
          .then(() => {
            document.querySelectorAll('.popup-toolDown.show').forEach((p) => p.classList.remove('show'));
            document.querySelector('.previewCart')?.classList.remove('active-tool');
            if (window.Shopify?.getCart && window.sharedFunctions?.updateSidebarCart) {
              window.Shopify.getCart((cart) => { window.sharedFunctions.updateSidebarCart(cart); });
            } else {
              window.location.reload();
            }
          })
          .catch(() => {
            document.querySelectorAll('.popup-toolDown.show').forEach((p) => p.classList.remove('show'));
            document.querySelector('.previewCart')?.classList.remove('active-tool');
          });
      }
    });
  }
}

if (!customElements.get('coupon-code')) {
  customElements.define('coupon-code', CouponCode);
}